import { CONTROLS_HIDE, CONTROLS_SHOW } from './constants';

export const showPlayerControls = dispatch => {
  dispatch({
    type: CONTROLS_SHOW,
    payload: true,
  });
};

export const hidePlayerControls = dispatch => {
  dispatch({
    type: CONTROLS_HIDE,
    payload: false,
  });
};
